import _ from 'lodash'

var equationHighlighter = {

	/**
	 * Parse an equation and return the markup version for dislay in a HTML
	 * Page. Each of the references in the equation will be highlighted.
	 */
	highlight: function (equationParser, equation) {
		var references = equationParser.parse(equation)
		return this.highlightTerms(equation, references)
	},

	/**
	 * Highlight each of the references in the equation
	 *
	 * @param {string} equation
	 *            The full equation
	 * @param {{}[]} references
	 *            An array of all references in the equation
	 * @param {boolean=} highlight
	 *            whether we really want to do highlighting (will be false in
	 *            some situations for IE11 for #8158)
	 * @returns {{
	 *     equation: string,
	 *     hasReference: boolean
	 * }} an equation where each reference is in a span with CSS
	 */
	highlightTerms: function (equation, references, highlight) {
		let highlightedEquation = ''
		highlight = _.isUndefined(highlight) ? true : highlight
		var suffix = highlight ? '</span>' : ''
		, hasReference
		_.forEach(references, function (reference, i) {
			var prefix = ''
			if (highlight) {
				prefix = '<span class="reference" ' +
					'data-type="' + reference.type + '" ' +
					'data-id="' + reference.id + '" ' +
					'data-index="' + reference.index + '">'
				hasReference = true
			}

			const prevReference = references[i-1]

			// get any non-reference token before this reference
			let startIndex = 0
			if (prevReference) {
				startIndex = prevReference.index + prevReference.match.length
			}
			const referencePrefix = equation.slice(startIndex, reference.index)

			// if we're at the end, grab the non-reference token after this reference, if any
			let referenceSuffix = ''
			if (i === references.length - 1) {
				referenceSuffix =
					equation.slice(reference.index + reference?.match?.length,
						equation.length)
			}


			highlightedEquation +=
				_.escape(referencePrefix) +
				prefix + _.escape(reference.match) + suffix +
				_.escape(referenceSuffix)
		})
		if (references.length === 0) {
			highlightedEquation = _.escape(equation)
		}
		return { equation: highlightedEquation, hasReference }
	}

}

export default equationHighlighter

equationHighlighter.__filename__ = 'components/equations/equation-highlighter.js'
